import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { Entidad } from 'src/app/models/Entidad';
import { TipoHecho } from 'src/app/models/TipoHecho';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalMontoComponent } from '../modal/modal-monto/modal-monto.component';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { Anho } from 'src/app/models/Anho';
import { Mes } from 'src/app/models/mes';
import { FuncionarioInvolucradoComponent } from '../Funcionario/funcionario-involucrado/funcionario-involucrado.component';
import { EmpresaInvolucradaComponent } from '../empresa/empresa-involucrada/empresa-involucrada.component';
import { openModalMensaje, getBooleanFlag, constobraPublica, DscTituloPaginator, constcontrataciones, strDscMsjPrgEliminar, openModalMensajePrg, isEmptyList, isNotEmptyList, GetAnho, ConvertStringDateStr, StrDscToolTipText, IntCantTotalCar, recupToolTipCar, limpiarTexto, ConvertDateTimeToStr, GetMes, GetFecActualMaxCal, NumIdTipoSistemaADM, NumIdMacroProcCONT , modificarTamañoModal, strMatTablePaginator} from 'src/app/general/variables';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import { Fur } from 'src/app/models/Fur';
import { FurXObraPublica } from 'src/app/models/FurXObraPublica';
import { ModalBusqObrpuComponent } from '../../ObraPublica/modal-busq-obrpu/modal-busq-obrpu.component';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ModalRegistroObraComponent } from '../../ObraPublica/modal-registro-obra/modal-registro-obra.component';
import { ModalHechoIrregularComponent } from '../../ObraPublica/modal-hecho-irregular/modal-hecho-irregular.component';
import { ModalIrregInfobrasComponent } from '../../ObraPublica/modal-irreg-infobras/modal-irreg-infobras.component';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { FichaXContratacion } from 'src/app/models/FichaXContratacion';
import { ModalBusqContratacionComponent } from '../modal-busq-contratacion/modal-busq-contratacion.component';
import { ModalRegHechoirreContrComponent } from '../modal-reg-hechoirre-contr/modal-reg-hechoirre-contr.component';
import { FichaXConratacionXHi } from 'src/app/models/FichaXContratacionXHi';
import { ModalRegContratacionComponent } from '../modal-reg-contratacion/modal-reg-contratacion.component';
import { ValidarFechaLength } from 'src/app/general/Funciones';
import { FurXObraPublicaXHi } from 'src/app/models/FurXObraPublicaXHi';
import { MacroProceso } from 'src/app/models/MacroProceso';
import { ExternosService } from 'src/app/services/externos/externos.service';
@Component({
  selector: 'app-hecho-irregular',
  templateUrl: './hecho-irregular.component.html',
  styleUrls: ['./hecho-irregular.component.css']
})
export class HechoIrregularComponent implements OnInit {

  @ViewChild(FuncionarioInvolucradoComponent) funcionarioInvolucradoC: FuncionarioInvolucradoComponent;
  @ViewChild(EmpresaInvolucradaComponent) empresaInvolucradaC: EmpresaInvolucradaComponent;

  // Modo lectura

  strDscTooltip: string = StrDscToolTipText;
  // private _flgLectura = false;
  flgLectura = false;
  // Icon editar
  iconEditar = faEdit;
  // Campos Hecho irregular - FUR
  cfurDschecho: string;
  // cfurFlgexismonto : string;
  // nfurIdtipohecho : number = null;
  nfurIdmacroproceso: number = null;
  cfurTipoHecho: any = {};
  descripcionTipoHecho: string;
  nfurImpmontoperj: number;
  strSeparador = ', ';
  otroTipo = '';
  flgMontoDesc = false;
  // Periodo
  select_anio_desde: string;
  select_anio_hasta: string;
  select_mes_hasta: string;
  select_mes_desde: string;
  rucEntidad: string;

  strFechaIniPer: string;
  strFechaFinPer: string;

  entidades: Entidad[] = [];
  // listTipoHechos : TipoHecho[] = [];
  listMacroProceso: MacroProceso[] = [];
  perjuicio_economico = false ;
  ocurre_hecho = false;
  precisa_hecho = false;
  // nfurIdtipohecho:number;
  // cObraPublica = constobraPublica;
   // cContratacion = NumIdMacroProcCONT;

   numIdSistemaCONT = NumIdMacroProcCONT;

  isEmptyList = isEmptyList;
  isNotEmptyList = isNotEmptyList;

  listObrasPublicas: FurXObraPublica[] = [];
  listContratacion: FichaXContratacion[] = [];
  nombreEntidad = '';
  codDepartEntidad = '';
  codProvEntidad = '';
  codDistEntidad = '';
  codEntidad = '';
  // flgEncontroContr:boolean = false;

  dataSourceObras: MatTableDataSource<FurXObraPublica>;
  dataSourceContr: MatTableDataSource<FichaXContratacion>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'nombreObra', 'estadoObra', 'costo', 'fechaInicio', 'fechaFin', 'Irregularidades', 'editar', 'eliminar'];
  matTableColumnsDefC = ['item', 'nomenclatura', 'objetoContr', 'dscObjeto', 'ValorRef', 'Irregularidades', 'editar', 'eliminar'];
  matTableColumnsEtiq = ['Ítem', 'Nombre Obra', 'Estado Obra', 'Costo', 'Fecha Inicio', 'Fecha Fin', 'Irregularidades', 'Editar', 'Eliminar'];
  strMatTablePaginator = strMatTablePaginator;
  matTableColumnsEtiqC = ['Ítem', 'Nomenclatura', 'Descripción de Obj.', 'Objeto de Contratación', 'Valor Referencial', 'Irregularidades', 'Editar', 'Eliminar'];
  // matTableColumnsDefC = ["nomenclatura"];
  // encontroObra : boolean = false;
  boolFlgEncontOPCT = false;

  iconAgregar = faPlus;
  iconEliminar = faTrash;
  iconVer = faEye;

  strFechaMaxCal = '';
  cfurFlgencobrapub = '';
  strDscToolTip0 = 'En general puede considerar fechas aproximadas de inicio y fin, a menos que conozca las fechas exactas';
  strDscToolTip1 = 'En general puede considerar fechas aproximadas de inicio y fin, a menos que conozca las fechas exactas';
  // iconEditar = iconEditar;

  // monto :number;



  listAnios: Anho[] = [];
  listMeses: Mes[] = [];

  formHechoIrregular = new FormGroup({
    select_entidades : new FormControl(''),
    select_entidades_inv : new FormControl(''),
    tipo_hecho : new FormControl(''),
    input_descripcion_hecho : new FormControl(''),
    flg_perjuicio_economico : new FormControl(''),
    flg_ocurre_hecho : new FormControl(''),
    select_anio_desde  : new FormControl(''),
    select_mes_desde : new FormControl(''),
    select_anio_hasta : new FormControl(''),
    select_mes_hasta : new FormControl(''),
    monto : new FormControl(''),
    cbkMontoDesconocido : new FormControl('')
  });
  constructor(protected entidadService: EntidadService, public dialog: MatDialog,
              private maestraService: MaestrasService,
              protected externosService: ExternosService,
              public mdModalIrreg: MatDialog) { }

  get input_descripcion_hecho() {
    return this.formHechoIrregular.get('input_descripcion_hecho');
  }

  _cambioFechaIni() {

    // console.log("====this.strFechaIniPer",this.strFechaIniPer)

    this.strFechaIniPer = ValidarFechaLength(this.strFechaIniPer);

    // console.log("====this.strFechaIniPer222",this.strFechaIniPer)

  }

  _cambioFechaFin() {

    this.strFechaFinPer = ValidarFechaLength(this.strFechaFinPer);

  }

  _reemplazarTexto(e) {


      const cleaned = limpiarTexto(e.target.value);

      // var list = e.target.value.split("\n");
	    // var cleaned = "";

      // for(var i= 0; i < list.length; i++)
      // {

      //   list[i] = list[i].replace(/^\s*[o\W]\s+/g, '');
      //   list[i] = list[i].replace(/[“]/g, '"');
      //   list[i] = list[i].replace(/[”]/g, '"');
      //   list[i] = list[i].replace(/[…]/g, "...");

      // }

      // cleaned = list.join("\n");

      e.target.value = cleaned;
      this.cfurDschecho = cleaned;

     }

  ngOnInit() {

    const anhoActual = GetAnho();

    this.strFechaMaxCal = GetFecActualMaxCal();

   // this.validarOcurreHecho();
    this.maestraService.obtenerAnho().subscribe(data => {
      // this.listAnios = data.filter(x=>Number(x.canhoCod) <= anhoActual && Number(x.canhoCod) >= anhoActual - 3);
      this.listAnios = data.filter(x => Number(x.canhoCod) <= anhoActual && Number(x.canhoCod) > anhoActual - 3).sort(function(a, b) {

        if (Number(a.canhoCod) > Number(b.canhoCod)) {
          return 1;
        }

        if (Number(a.canhoCod) < Number(b.canhoCod)) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

    });

    this.maestraService.obtenerMes().subscribe(data => {

      data.sort(function(a, b) {

        if (Number(a.cmesCod) > Number(b.cmesCod)) {
          return 1;
        }

        if (Number(a.cmesCod) < Number(b.cmesCod)) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      // console.log("===================MESESSSS");
      // console.log(data)

      this.listMeses = data;
    });

    // this.maestraService.obtenerTipoHecho().subscribe(data=>{this.listTipoHechos = data;});

    this.externosService.listarMacroProceso(NumIdTipoSistemaADM).subscribe(
      data => {
        this.listMacroProceso = data;

      });

  }

  _cambioTipoHecho(nfurIdmacroproceso) {
    console.log("_cambioTipoHecho:"+nfurIdmacroproceso);
    this.cambioExisteMonto(false);
    this.listMacroProceso.forEach(cat => {
      //console.log(cat);
      if (cat.nmacroprocesoId == nfurIdmacroproceso) {
        this.cfurTipoHecho = cat;
        console.log(cat);
      }
    });
    //console.log(this.cfurTipoHecho);
  }

  _recupFlgTipHechoObra() {

    // var vTipHecho:number = (this.nfurIdtipohecho ? 0:this.nfurIdtipohecho);

    return (this.nfurIdmacroproceso == this.numIdSistemaCONT && this.cfurFlgencobrapub == 'SI');

  }

  _recupFlgTipHechoContr() {

    return (this.nfurIdmacroproceso == this.numIdSistemaCONT && this.cfurFlgencobrapub == 'NO');

  }

  _recupFlgTipHechoObraContr() {

    return this._recupFlgTipHechoObra() || this._recupFlgTipHechoContr();

  }


  _verHechoIrregularContr(data: FichaXContratacion) {

    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = false;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      contratacion : data

    };
    configuracionGlobal.width = '80%';
    configuracionGlobal.maxHeight = 600;
    // width: '50%',height:'87%'
    this.dialog.open(ModalHechoIrregularComponent, configuracionGlobal);

  }


  _cambioIndicacion() {

    this.strDscTooltip = recupToolTipCar(this.cfurDschecho);

  }

  _editarHechoIrregularContr(data: FichaXContratacion) {

    let vListHechoIrregular: FichaXConratacionXHi[] = [];

    vListHechoIrregular = JSON.parse(JSON.stringify(data.listaFichaPorContratacionPorHechoIrregular));

    const dialogRef = this.dialog.open(ModalRegHechoirreContrComponent, {
      // width: '50%',height:'87%',
      width: '80%', height: '87%',
    data: {listHi : vListHechoIrregular}});

    dialogRef.afterClosed().subscribe(result => {

      if (result != null) {

        // this._RecupDscHechoCONT(result);

        this.listContratacion[0].listaFichaPorContratacionPorHechoIrregular = result;

      }

      // console.log(this.furObraPublica);

    });

  }

  setEntidadHecho(data: Entidad) {
    this.nombreEntidad = data.centNombre;
    this.codEntidad = data.centCodigo;
    this.rucEntidad = data.centRuc;
    this.codDepartEntidad = data.centDirdep;
    this.codProvEntidad = data.centDirpro;
    this.codDistEntidad = data.centDirdis;
  }

  // _cambiarEncontroObra(evento){
  //   //this.encontroObra = evento.checked;
  // }

  // _cambiarEncontroContr(evento){
  //   //this.flgEncontroContr = evento.checked;
  // }

  _cambiarEncontroOPCT(evento) {

    this.boolFlgEncontOPCT = evento.checked;
  }

  cambioExisteMonto(cbkMonto) {

    this.perjuicio_economico = cbkMonto.checked;
    if (cbkMonto.checked) {
      this.abrirModal(false);
    } else {
     // this.formHechoIrregular.get('monto').setValue(0);
     //this.nfurImpmontoperj = 0;
    }
  }

  _verHechoIrregular(obra) {
    this._abrirModalIrregularidades(obra);
  }

  _abrirModalIrregularidades(obra) {
    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = false;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      obra
    };
    configuracionGlobal.width = '80%';
    configuracionGlobal.maxHeight = 600;
    this.dialog.open(ModalHechoIrregularComponent, configuracionGlobal);
  }

  _editarHechoIrregular(obra: FurXObraPublica) {

    const dialogRef = this.mdModalIrreg.open(ModalIrregInfobrasComponent, { width: '80%', height: '87%', data: {obraPub : obra, editar: true}});

    dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          obra = result;
        }


    });
  }

  _eliminarObras(obra) {

    openModalMensajePrg('Obras Públicas', strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.listObrasPublicas.splice(this.listObrasPublicas.indexOf(obra), 1);


      }

    });


  }

  getFlgExisteOP() {

    let boolFlgExisteOP = false;

    if (!isEmptyList(this.listObrasPublicas)) {

      boolFlgExisteOP = true;

    }

    return boolFlgExisteOP;

  }

  _eliminarContratacion(contratacion) {

    openModalMensajePrg('Contratación', strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.listContratacion.splice(this.listContratacion.indexOf(contratacion), 1);


      }

    });

  }

  _abrirModalRegistroObra() {
    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;
    // configuracionGlobal.width = "90%";
    // configuracionGlobal.height = "75%";
    // configuracionGlobal.maxHeight = 600;
    configuracionGlobal.width = '80%';
    configuracionGlobal.height = '80%';
    configuracionGlobal.maxHeight = 600;

    configuracionGlobal.data = {
      // listDenunciado:this.listDenunciado
    };

    const  modal = this.dialog.open(ModalRegistroObraComponent, configuracionGlobal);
    modal.afterClosed().subscribe(
         data => {
            if (data != null) {
              // console.log(data);
              // console.log(this.listObrasPublicas);
              this.listObrasPublicas.push(data);

              // this._RecupDscHechoOP(this.listObrasPublicas[0].listaFurPorObraPubPorHechoIrr);
              // console.log(this.listObrasPublicas);
              this._cargarTableMaterialObra();
            }
         }
      );
  }

  _abrirModalRegistroContr() {
    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.width = '80%';
    configuracionGlobal.height = '80%';
    configuracionGlobal.maxHeight = 600;

    configuracionGlobal.data = {
      // listDenunciado:this.listDenunciado
    };

    const  modal = this.dialog.open(ModalRegContratacionComponent, configuracionGlobal);
    modal.afterClosed().subscribe(
         data => {
            if (data != null) {
              // console.log("==================data");
              //  console.log(data);
              // console.log(this.listContratacion);
              this.listContratacion.push(data);
              // this._RecupDscHechoCONT(this.listContratacion[0].listaFichaPorContratacionPorHechoIrregular);
              // console.log(this.listObrasPublicas);
              this._cargarTableMaterialContr();
            }
         }
      );
  }



  editarMonto() {

    // this.perjuicio_economico = cbkMonto.checked;
    // if(cbkMonto.checked){

      this.abrirModal(true);

    // }
  }

  _enviarHecho() {
    // let tipHechoEnvio;
    // let tipoHechoSelec = this.formEntidadHecho.get('select_tipo_hecho').value;
    // let tipoHechoSelec = this.nfurIdtipohecho;

    // this.flgObrasPub = (tipoHechoSelec == 1) ? true:false;

    // this.tipoHechos.forEach(tipHecho => {

    //   if(tipHecho.ntipohechoId == tipoHechoSelec){
    //       tipHechoEnvio = tipHecho;

    //       this.emitirHecho(tipHechoEnvio);
    //     }
    // });
  }

  _abrirModalObras() {
    let configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      entidad : this.nombreEntidad,
      codDepartEnt : this.codDepartEntidad,
      codProvEnt : this.codProvEntidad,
      codDistEnt : this.codDistEntidad,

    };

    // configuracionGlobal.width = "90%";
    configuracionGlobal = modificarTamañoModal(configuracionGlobal);

    const  modal = this.dialog.open(ModalBusqObrpuComponent, configuracionGlobal);

    modal.afterClosed().subscribe(
          data => {

            if (data != null) {
              this.listObrasPublicas.push(data);

              // this._RecupDscHechoOP(this.listObrasPublicas[0].listaFurPorObraPubPorHechoIrr);

              this._cargarTableMaterialObra();

            }

          } );


  }
  _RecupDscHechoCONT(listaHechoIrr: FichaXConratacionXHi[]) {

      this.cfurDschecho = '';

      listaHechoIrr.forEach(element => {

        this.cfurDschecho = this.cfurDschecho + element.cfichaxcontxhiDschi + this.strSeparador;

      });

      this.cfurDschecho = this.cfurDschecho.substr(0, this.cfurDschecho.lastIndexOf(this.strSeparador));

  }

  _RecupDscHechoOP(listaHechoIrr: FurXObraPublicaXHi[]) {

      this.cfurDschecho = '';

      listaHechoIrr.forEach(element => {

        this.cfurDschecho = this.cfurDschecho + element.cfurxobpxhiDschi + this.strSeparador;

      });

      this.cfurDschecho = this.cfurDschecho.substr(0, this.cfurDschecho.lastIndexOf(this.strSeparador));

  }

  _abrirModalContratacion() {
    let configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      entidad : this.codEntidad,
      ruc : this.rucEntidad

      // cpersonaNroDoc:personaArg.cpersonaNroDoc,
      // cpersonaRazonsocial:personaArg.cpersonaRazonsocial,flgValida:flgValidaArg,listaEmpresa: listaEmpresaArg
    };

    // configuracionGlobal.width =  "calc(100% - 30px)";
    // configuracionGlobal.maxWidth =  "100%";

    configuracionGlobal = modificarTamañoModal(configuracionGlobal);


    const  modal = this.dialog.open(ModalBusqContratacionComponent, configuracionGlobal);

    modal.afterClosed().subscribe(
          data => {

            if (data != null) {

              // console.log("==================data");
              //  console.log(data);

               // this.listContratacion[0].

              this.listContratacion.push(data);

              // this._RecupDscHechoCONT(this.listContratacion[0].listaFichaPorContratacionPorHechoIrregular);

              // this.cfurDschecho = "";

              // this.listContratacion[0].listaFichaPorContratacionPorHechoIrregular.forEach(element => {

              //   this.cfurDschecho = this.cfurDschecho + element.cfichaxcontxhiDschi + ", ";

              // });

              // this.cfurDschecho = this.cfurDschecho.substr(0, this.cfurDschecho.lastIndexOf(", "));

              // console.log("==0=this.cfurDschecho",this.cfurDschecho);

              // this.listContratacion[0].listaFichaPorContratacionPorHechoIrregular


              this._cargarTableMaterialContr();
             /* this.obtenerProvincias(data.centDirdep);
              this.obtenerDistritos(data.centDirdep,data.centDirpro);
              this.llenarFormulario(data);*/
            }

          } );


  }

  _cargarTableMaterialObra() {

    setTimeout(() => {

      this.dataSourceObras = new MatTableDataSource(this.listObrasPublicas);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      this.dataSourceObras.paginator = this.paginator;
      this.dataSourceObras.sort = this.sort;

    }, 10);

  }

  _cargarTableMaterialContr() {

    setTimeout(() => {

      // console.log("=========this.listContratacion");
      // console.log(this.listContratacion);

      this.dataSourceContr = new MatTableDataSource(this.listContratacion);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      this.dataSourceContr.paginator = this.paginator;
      this.dataSourceContr.sort = this.sort;

    }, 0);

  }


  abrirModal(editar: boolean) {
    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = false;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {editar, monto : this.nfurImpmontoperj,
                            cbkMonto :  this.flgMontoDesc};

    configuracionGlobal.width = '80%';
    const  modal = this.dialog.open(ModalMontoComponent, configuracionGlobal);

    modal.afterClosed().subscribe(
          data => {
            console.log(data);
            if (data != null && data!=undefined) {
                this.nfurImpmontoperj =  data.monto;
                this.flgMontoDesc = data.cbk_monto;
              } else {
               // this.perjuicio_economico = !this.perjuicio_economico;
              }
          }
      );
  }

  cambioPrecisaHecho(cbkOcurrioHecho) {
    let fechaActual: Date = null;

    this.precisa_hecho = cbkOcurrioHecho.checked;

    if (this.precisa_hecho == true) {

      fechaActual = new Date();

      // this.strFechaFinPer = fechaActual.getFullYear() + "-0" + fechaActual.getMonth()  + "-0" + fechaActual.getDate();

      //this.strFechaFinPer = this.strFechaMaxCal;

    } else {
      this.strFechaIniPer = '';
      this.strFechaFinPer = '';

    }

  }
  cambioOcurreHecho(cbkOcurrioHecho) {
    let fechaActual: Date = null;

    this.ocurre_hecho = cbkOcurrioHecho.checked;

    if (this.ocurre_hecho == true) {

      fechaActual = new Date();

      // this.strFechaFinPer = fechaActual.getFullYear() + "-0" + fechaActual.getMonth()  + "-0" + fechaActual.getDate();

      this.strFechaFinPer = this.strFechaMaxCal;

    } else {
      this.strFechaIniPer = '';
      this.strFechaFinPer = '';


    }

  }

  _cambioMesIni() {

    this.select_anio_desde = null;
    this.select_anio_hasta = null;
    this.select_mes_hasta = null;

    if (this._validarPeriodo()) {

      setTimeout(() => {

        this.select_mes_desde = null;

      }, 1);

    }



  }

  _cambioAnhoIni() {

    this.select_anio_hasta = null;
    this.select_mes_hasta = null;


    if (this._validarPeriodo()) {

      setTimeout(() => {

        this.select_anio_desde = null;

      }, 1);


    }



  }

  _cambioMesFin() {

    this.select_anio_hasta = null;

    if (this._validarPeriodo()) {

      setTimeout(() => {

        this.select_mes_hasta = null;

      }, 1);



    }



  }

  _cambioAnhoFin() {

    if (this._validarPeriodo()) {

      setTimeout(() => {

        this.select_anio_hasta = null;

      }, 1);


    }

    // console.log("==============this.select_anio_hasta");
    // console.log(this.select_anio_hasta);

  }

  _validarPeriodo() {

    const desdeAnio = Number.parseInt(this.select_anio_desde);
    const hastaAnio = Number.parseInt(this.select_anio_hasta);
    const desdeMes = Number.parseInt(this.select_mes_desde);
    const hastaMes = Number.parseInt(this.select_mes_hasta);
    let flgError = false;

    if ( desdeAnio > hastaAnio) {

      openModalMensaje('Periodo', 'El año del campo Hasta no puede ser menor que el mes del campo Desde', this.dialog);

      flgError = true;

      // this.select_anio_hasta=null;
    } else {
      if (desdeAnio ==  hastaAnio) {
          if ( desdeMes > hastaMes) {
            openModalMensaje('Periodo', 'El mes del campo Hasta no puede ser menor que el mes del campo Desde', this.dialog);
            flgError = true;
            // this.formHechoIrregular.get('select_mes_desde').setValue(null);
          }
      }
    }

    return flgError;

  }

  validarOcurreHecho() {
    if (this.ocurre_hecho) {
      this.formHechoIrregular.get('select_mes_desde').enable();
      this.formHechoIrregular.get('select_anio_desde').enable();
      this.formHechoIrregular.get('select_mes_hasta').enable();
      this.formHechoIrregular.get('select_anio_hasta').enable();
    } else {
      this.formHechoIrregular.get('select_mes_desde').disable();
      this.formHechoIrregular.get('select_anio_desde').disable();
      this.formHechoIrregular.get('select_mes_hasta').disable();
      this.formHechoIrregular.get('select_anio_hasta').disable();
    }
  }

  /*
  get  flgLectura() : boolean{
    return this._flgLectura;
  }

  set flgLectura(valor : boolean){
    this._flgLectura = valor;

    if(this._flgLectura){
      this.modoLectura(this._flgLectura);
    }
  }
*/

  getStringPerjuicioEconomico(): string {
    return this.perjuicio_economico ? 'SI' : 'NO';
  }


  getStringFlgMontoDesconocido(): string {
    return this.flgMontoDesc ? 'SI' : 'NO';
  }


  setHechoIrregularComponent(fur: Fur) {

    // console.log("==================setHechoIrregularComponent");
    // console.log(fur);

    this.cfurDschecho = fur.cfurDschecho;
    this.perjuicio_economico = getBooleanFlag(fur.cfurFlgexismonto );
    if (this.perjuicio_economico) {
      this.nfurImpmontoperj = fur.nfurImpmontoperj;
      this.flgMontoDesc =  getBooleanFlag(fur.cfurFlgemontodesc);
    }
    this.ocurre_hecho = getBooleanFlag(fur.cfurFlghdenconocu);
    this.strFechaIniPer = ConvertStringDateStr(fur.strDfurFeciniperiodo, 1);
    this.strFechaFinPer = ConvertStringDateStr(fur.strDfurFecfinperiodo, 1);
    // this.select_anio_desde = String(fur.nfurPeriodoohini).substring(0,4);
    // this.select_mes_desde = String(fur.nfurPeriodoohini).substring(4,6);
    // this.select_anio_hasta = String(fur.nfurPeriodoohfin).substring(0,4);
    // this.select_mes_hasta =  String(fur.nfurPeriodoohfin).substring(4,6);;

    // this.nfurIdtipohecho = fur.nfurIdtipohecho;
    this.nfurIdmacroproceso = fur.nfurIdmacroproceso;

    this.listObrasPublicas = fur.listaFurPorObraPublica;
    this.listContratacion = fur.listaFichaPorContratacion;


    this._cargarTableMaterialObra();
    this._cargarTableMaterialContr();

    this.funcionarioInvolucradoC.setFuncionarioComponent(fur);

  }

  hechoIrregularCReadEnable() {
    this.flgLectura = true;
  }

  hechoIrregularCReadDisable() {
    this.flgLectura = false;
  }

  modoLectura(valor: boolean) {
    if (valor) {
        // Formulario
        this.formHechoIrregular.controls.select_entidades_inv.disable();
        this.formHechoIrregular.controls.tipo_hecho.disable();
        this.formHechoIrregular.controls.input_descripcion_hecho.disable();
        this.formHechoIrregular.controls.flg_ocurre_hecho.disable();
        this.formHechoIrregular.controls.select_anio_desde.disable();
        this.formHechoIrregular.controls.select_mes_desde.disable();
        this.formHechoIrregular.controls.select_anio_hasta.disable();
        this.formHechoIrregular.controls.select_mes_hasta.disable();
        this.formHechoIrregular.controls.monto.disable();
        this.formHechoIrregular.controls.cbkMontoDesconocido.disable();
        this.formHechoIrregular.controls.flg_perjuicio_economico.disable();
        //

    }
  }
}
